// extracted by mini-css-extract-plugin
export default {"container":"SingleLineNotification_container__nlxWs","new":"SingleLineNotification_new__GuXVm","detailsToggle":"SingleLineNotification_detailsToggle__Q4nsp"};